export const alphanumericRegex = '^[A-Za-z0-9_][A-Za-z0-9_\\s]*$'
